export const ESTABLISHMENT_MODULE_TYPES = [
  'establishments',
  'establishments_for_families',
  'establishments_for_couples',
  'establishments_for_pet_friendly',
];

export const DEFAULT_MODULES_POSITION = {
  establishments: 1,
  establishments_for_couples: 12,
  establishments_for_families: 12,
  establishments_for_pet_friendly: 12,
  relateds: 90,
  services: 10,
};

export const AIRBNB_SEO_INLINE = {
  type: 'ad-inline',
};

export const TIPOLOGY_DESTINATIONS = {
  'co.uk': {
    country: 'gb',
    is_new: false,
    lat: 55.378051,
    lat_ne: 60.91569999999999,
    lat_sw: 34.5614,
    lng: -3.435973,
    lng_ne: 33.9165549,
    lng_sw: -8.8988999,
    name: 'United Kingdom',
    place_id: 'ChIJqZHHQhE7WgIReiWIMkOg-MQ',
    polygon_id: null,
    zoom: 5,
    path: '/s'
  },
  com: {
    country: 'es',
    is_new: false,
    lat: 40.46366700000001,
    lat_ne: 43.8504,
    lat_sw: 27.4985,
    lng: -3.74922,
    lng_ne: 4.6362,
    lng_sw: -18.2648001,
    name: 'España',
    place_id: 'ChIJi7xhMnjjQgwR7KNoB5Qs7KY',
    polygon_id: null,
    zoom: 5,
    path: '/s'
  },
  'com.mx': {
    country: 'mx',
    is_new: false,
    lat: 23.634501,
    lat_ne: 32.7186534,
    lat_sw: 14.3895,
    lng: -102.552784,
    lng_ne: -86.5887,
    lng_sw: -118.6523001,
    name: 'Mexico',
    place_id: 'ChIJU1NoiDs6BIQREZgJa760ZO0',
    polygon_id: null,
    zoom: 5,
    path: '/s'
  },
  de: {
    country: 'de',
    is_new: false,
    lat: 51.165691,
    lat_ne: 55.0815,
    lat_sw: 47.2701115,
    lng: 10.451526,
    lng_ne: 15.0418962,
    lng_sw: 5.8663425,
    name: 'Deutschland',
    place_id: 'ChIJa76xwh5ymkcRW-WRjmtd6HU',
    polygon_id: null,
    zoom: 5,
    path: '/s'
  },
  fr: {
    country: 'fr',
    is_new: false,
    lat: 46.227638,
    lat_ne: 51.1241999,
    lat_sw: 41.3253001,
    lng: 2.213749,
    lng_ne: 9.6624999,
    lng_sw: -5.5591,
    name: 'France',
    place_id: 'ChIJMVd4MymgVA0R99lHx5Y__Ws',
    polygon_id: null,
    zoom: 5,
    path: '/s'
  },
  it: {
    country: 'it',
    is_new: false,
    lat: 41.87194,
    lat_ne: 47.092,
    lat_sw: 35.4897,
    lng: 12.56738,
    lng_ne: 18.7975999,
    lng_sw: 6.6267201,
    name: 'Italia',
    place_id: 'ChIJA9KNRIL-1BIRb15jJFz1LOI',
    polygon_id: null,
    zoom: 5,
    path: '/s'
  },
  jp: {
    country: 'jp',
    is_new: false,
    lat: 38.2413886,
    lat_ne: 45.65827371,
    lat_sw: 30.82450349,
    lng: 137.66834449,
    lng_ne: 145.88611793,
    lng_sw: 129.45057106,
    name: 'Japan',
    place_id: 'ChIJLxl_1w9OZzQRRFJmfNR1QvU',
    polygon_id: null,
    zoom: 5,
    path: '/s'
  },
};

export const REL_PER_MODULE = 8;
export const PAGINATION = 'pagination';
export const TIPOLOGY = 'tipology';
export const PAGINATION_MODULES = ['h1', 'textSection'];
export const DISCARDED_MODULES = ['services', 'location_images'];
